import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from "@/lib/utils";
export function Slider({ value, onChange, min = 0, max = 100, step = 1, className, ...ariaProps }) {
    return (_jsx("input", { type: "range", min: min, max: max, step: step, value: value, "aria-label": ariaProps["aria-label"], "aria-labelledby": ariaProps["aria-labelledby"], onChange: (e) => onChange(Number(e.target.value)), className: cn("w-full h-2 bg-muted rounded-lg appearance-none cursor-pointer accent-primary", className) }));
}
